import type { ApiRoute, BffInput } from "@slfinrtl/ui-bff-routes"
import type { AxiosResponse } from "axios"
import type { AxiosParams } from "./getAxiosInstance/AxiosParams"
import { getAxiosInstance } from "./getAxiosInstance/getAxiosInstance"

export async function callBff<RequestPathParams, RequestQueryParams, RequestBody, ResponseType>(
	axiosContext: AxiosParams,
	route: ApiRoute<RequestPathParams, RequestQueryParams, RequestBody, ResponseType>,
	input: BffInput<RequestPathParams, RequestQueryParams, RequestBody>,
): Promise<ResponseType> {
	const axiosInstance = await getAxiosInstance(axiosContext)

	const url = route.buildUrl(input.pathParams)
	let response: AxiosResponse<ResponseType>
	switch (route.method) {
		case "get":
			response = await axiosInstance.get(url, {
				params: input.queryParams,
			})
			break
		case "post":
			response = await axiosInstance.post(url, input.body && JSON.stringify(input.body), {
				params: input.queryParams,
			})
			break
		case "delete":
			response = await axiosInstance.delete(url, {
				params: input.queryParams,
			})
			break
		case "patch":
			response = await axiosInstance.patch(url, input.body && JSON.stringify(input.body), {
				params: input.queryParams,
			})
			break
		case "put":
			response = await axiosInstance.put(url, input.body && JSON.stringify(input.body), {
				params: input.queryParams,
			})
			break
	}

	return response.data
}
